import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Typography from '../../../../common-components/Typography';
import ModalFooter from '../../../../common-components/ModalFooter';
import { Modal } from '../../../../common-components/modal';
import { STATIC_PATH } from '../../../../constants/config';
import vmTheme from '../../../../constants/theme';
import { font } from '../../../../constants/font';
import content from '../../../../constants/content';
import { PLAN } from '../../../../constants';

const Flex = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 24px;
`
const ErrorModal = ({ show, onClose, onClick, onCloseModal }) => {
    const theme = useSelector((state) => state.app.get('theme'));
    const userDetails = useSelector((store) => store.userDetails);
    const { plan } = userDetails;
    
    return (
        <Modal
            width="400px"
            height="auto"
            showModal={show}
            onClose={onCloseModal}
        >
            <Flex>
                <img src={`${STATIC_PATH}vm-error-info.svg`} alt="Error" />
                <Typography
                    content={content.FILE_SIZE_EXCEEDS_PLAN_LIMIT}
                    enableTrim={false}
                    color={vmTheme[theme].panelPrimaryColor}
                    font={font.bold_20_26}
                    padding={"0px"}
                    align='center'
                />
                <ModalFooter
                    confirmText={plan === PLAN.ENTERPRISE ? content.CONTACT_US : content.UPGRADE_TO_ENTERPRISE}
                    cancelText={content.TRY_SMALLER_FILE}
                    onSave={onClick}
                    onClose={onClose}
                    fontsColor={vmTheme[theme].polarColor}
                    backgroundColor={vmTheme[theme].secondaryBorderColor}
                    cancelBackground={vmTheme[theme].btnBgLightColor}
                    padding="16px"
                    justifyContent="center"
                />
            </Flex>
        </Modal>
    );
};

ErrorModal.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    onClick: PropTypes.func,
    onCloseModal: PropTypes.func,
};

export default ErrorModal;

